import dayjs from "dayjs";

export const DATE_FORMAT = "YYYY-MM-DD";
export const DATE_TIME_FORMAT = "YYYY-MM-DD HH:mm:ss";

export function dateFormat(date?: string) {
  return date ? dayjs(date).format(DATE_FORMAT) : "-";
}

export function dateTimeFormat(date?: string) {
  return date ? dayjs(date).format(DATE_TIME_FORMAT) : "-";
}
